export enum UserSourceType {
  internal = 'internal',
  activeDirectory = 'activeDirectory',
  sso = 'sso',
}
